<template>
  <div>
    <p class="form-text text-secondary text-smaller-1 px-3 pb-1 m-0">
      If you have a Special Project code, enter it here; otherwise, leave this
      blank.
    </p>
    <p class="form-text text-secondary text-smaller-1 px-3 pb-1 m-0">
      What is this? Occasionally, we create book/calendar projects geared to one
      specific cause, town/location, etc. We give out a special code when we
      announce the project is in the works. Anyone who wants to have their dog
      pic considered for inclusion in that special book/calendar needs to enter
      that code here.
    </p>
    <p class="form-text text-secondary text-smaller-1 px-3 pb-1 m-0">
      Please note: Entering a code here does not guarantee inclusion in the
      project. Your image will be evaluated for use in the special book/calendar
      just as any other image is evaluated for
      <span class="italic">any</span> of our books/calendars.
    </p>

    <p class="form-text text-secondary text-smaller-1 px-3 pb-1 m-0">
      Finally, if you <span class="italic">do</span> enter a code, we don't
      evaluate your image for inclusion in <strong>just</strong> that special
      project. In other words, it's possible your image will end up in any of
      our other books and calendars.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>